module.exports = __webpack_public_path__ + "img/logo-ext.14b1cac7.png";